import { BlogData } from '../../types';

// Standalone blog (not the work case studies): essays and thoughts.
// Article bodies live as Markdown under src/data/blog-content/.
const blogData: BlogData = {
  title: "Blog",
  intro: "Politics and society, the questions that keep nagging at me. Essays beyond the project work.",
  posts: [
    {
      slug: "wie-viel-disruption-vertraegt-der-mensch",
      title: "How Much Disruption Can People Take?",
      date: "2026-10-02",
      teaser: "The car had a century, the internet is still uncharted territory after 30 years, and AI is arriving on top of it. An essay on why societies can no longer keep up, why this time the corporations themselves are the disruptors, and why regulation is not a killjoy.",
      tags: ["AI", "Disruption", "Society", "Regulation", "Big Tech", "Essay"],
      readingMinutes: 13,
      image: "/assets/img/blog/wie-viel-disruption-vertraegt-der-mensch_og.webp"
    }
  ]
};

export default blogData;
